import {
  FormControl,
  MenuItem,
  Select,
  Grid,
  Autocomplete,
  TextField,
  Checkbox,
} from "@mui/material";
import { Bar } from "react-chartjs-2";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import OutlinedInput from '@mui/material/OutlinedInput';
import ClearIcon from '@mui/icons-material/Clear';
import InputLabel from '@mui/material/InputLabel';
import ListItemText from '@mui/material/ListItemText';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useSelector } from "react-redux";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import React, { useEffect, useState } from "react";
import "./style.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
ChartJS.register(ChartDataLabels);

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
  'Kelly Snyder',
];
function OverAllCostByScenarioChart(props) {
  //console.log("Over All cost-------------------------------", props.overAllCostData)
  console.log(props, "props from overall");

  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderData = useSelector(
    (state) => state.InputDataReducers.selectedFolderData
  );
  
  console.log(selectedFolderData, "selectedFolderData");
  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  
  const options = {
    plugins: {
      responsive: true,
      maintainAspectRatio: false,
      categoryPercentage: 0.8,
      barPercentage: 0.5,
      datalabels: {
        anchor: "end",
        align: "top",
        // color: "black",
        offset: -3,
        font: {
          weight: "bold",
          size: 12,
        },
        // formatter: Math.round,
        formatter: (value, context) => {
          const datasetArray = [];
          let total;
          function totalSum(total, datapoint) {
            return total + datapoint;
          }
          context.chart.data.datasets.forEach((dataset) => {
            if (dataset.data[context.dataIndex] !== undefined) {
              datasetArray.push(dataset.data[context.dataIndex]);
            }
          });
          total = datasetArray.reduce(totalSum, 0);
          if (context.datasetIndex === datasetArray.length - 1) {
            // return NumberFormater(total) + ' Cr';
            return "";
          } else {
            return "";
          }
        },
      },
      title: {
        display: false,
      },
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            var label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += context.parsed.y.toFixed(2);
            }
            return label;
          },
        },
      },
      // tooltip:
      // {
      //     callbacks: {
      //         title: function(item){return item},
      //         label: function (tooltipItem) { console.log('ToolTip',tooltipItem);
      //             return tooltipItem + 'cr';},
      //     }
      // }
      // ,
      // tooltip: {
      //     callbacks: {
      //         title: function (e) {
      //             return ``;
      //         },
      //         label: function (tooltipItem) {
      //             let cost = datasets[tooltipItem.datasetIndex].data[0];
      //             let displayLabel = datasets[tooltipItem.datasetIndex].label + ': ';
      //             //return `${NumberFormater(cost)} Cr \n ${displayLabel}`;
      //             return `${displayLabel}${NumberFormater(cost)} Cr }`;
      //         }
      //     }
      // }
    },
    responsive: true,
    maintainAspectRatio: true,
    categorySpacing: 40,
    scales: {
      x: {
        barThickness: 6, // number (pixels) or 'flex'
        maxBarThickness: 8, // number (pixels)
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "S C E N A R I O",
        },
        barThickness: 8,
        barPercentage: 0.5,
        categorySpacing: 40,
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: "probability",
        },
      },
      y: {
        // beginAtZero: true,
        grid: {
          display: false,
        },
        title: {
          display: true,
          text: "Cost (in Crore)",
        },
        ticks: {
          callback: function (value, index, ticks) {
            return value.toFixed(2);
          },
        },

        stacked: true,
      },
    },
  };

  // const labels = ['Baseline', 'Scenario 1'];
  // const labels = []
  const [labels, setLabels] = useState([]);
  useEffect(() => {
    if (props.overAllCostData.length > 0) {
      const finalLabels = [];
      props.overAllCostData?.map((data) => {
        finalLabels.push(data?.chartname);
      });
      setLabels(finalLabels);
    }
  }, [props.overAllCostData]);
  const temp1 = 5;
  const temp2 = 9;


  var datasets = [];

  const homeDatasets = [
    {
      label: "Landed Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Landed Cost"]),
      backgroundColor: "#FF9998",
    },
    {
      label: "Conversion Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Conversion Cost"]),
      backgroundColor: "#FFEC9A",
    },
    {
      label: "Pri Transportation Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Pri Transportation Cost"]),
      backgroundColor: "#FFC000",
    },
  ];

  const nutritiondatasets = [
    {
      label: "RMPM transportation cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["RMPM Transportation cost"]),
      backgroundColor: "#FF9998",
    },
    {
      label: "RMPM procurement cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["RMPM Procurement cost"]),
      backgroundColor: "#b8ffbd",
    },
    {
      label: "Processing cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Processing cost"]),
      backgroundColor: "#FFEC9A",
    },
    {
      label: "SFG transportation cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["SFG transportation cost"]),
      backgroundColor: "#A3E1D2",
    },
    {
      label: "Packaging cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["Packaging cost"]),
      backgroundColor: "#00B190",
    },
    {
      label: "RMPM Landed Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["RMPM Landed cost"]),
      backgroundColor: "#b8ffbd",
    },
     {
      label: "RMPM Landed Cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map((item) => item["RM Landed Cost"]),
      backgroundColor: "#b8ffbd",
    },
    {
      label: "Primary Transportation cost",
      data:
        props.overAllCostData &&
        props.overAllCostData.map(
          (item) => item["Primary Transportation cost"]
        ),
      backgroundColor: "#FFC000",
    },
  ];

  if (selectedCategoryId === 1) {
    datasets = homeDatasets;
  } else {
    datasets = nutritiondatasets;
  }

    
    const [selectedScenarios, setSelectedScenarios] = useState([])
 
    console.log(selectedScenarios, "selectedValue");

  
    let uc = localStorage.getItem("selectedUsecase");
    let sr = localStorage.getItem("selectedRadio");
    const [shortTermStatus, setShortTermStatus] = useState(false);
    const [mediumTermStatus, setMediumTermStatus] = useState(false);
    useEffect(() => {
      if (uc === "Short Term") {
        if (sr === "masterData") {
          setShortTermStatus(true);
        } else {
          setShortTermStatus(false);
        }
      } else {
        if (sr === "masterData") {
          setMediumTermStatus(true);
        } else {
          setMediumTermStatus(false);
        }
      }
    }, [uc, sr]);
    console.log(uc, sr, shortTermStatus, mediumTermStatus, "statusss");
    
  
    const nutritionScenarioOptions = [
      {
        scenario_id: 0,
        folder_id: 347,
        scenario: "Primary Transportation Cost",
        filetype: 1,
        scenario_time: null,
        number: 1476,
      },
      {
        scenario_id: 1477,
        folder_id: 347,
        scenario: "Packaging Cost",
        filetype: 2,
        scenario_time: "",
        number: 1477,
      },
      {
        scenario_id: 1480,
        folder_id: 347,
        scenario: "SFG Transportation Cost",
        filetype: 2,
        scenario_time: null,
        number: 1480,
      },
      {
        scenario_id: 1480,
        folder_id: 347,
        scenario: "Processing Cost",
        filetype: 2,
        scenario_time: null,
        number: 1480,
      },
      // {
      //   scenario_id: 1480,
      //   folder_id: 347,
      //   scenario: "RMPM Landed cost",
      //   filetype: 2,
      //   scenario_time: null,
      //   number: 1480,
      // },
      {
        scenario_id: 1480,
        folder_id: 347,
        scenario: "RMPM transportation cost",
        filetype: 2,
        scenario_time: null,
        number: 1480,
      },
      {
        scenario_id: 1480,
        folder_id: 347,
        scenario: "RMPM procurement cost",
        filetype: 2,
        scenario_time: null,
        number: 1480,
      },
  ];
  
  const nutritionScenarioOptions2 = [
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Landed cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM transportation cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM procurement cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
  ];  
  const nutritionScenarioOptions3 = [
    {
      scenario_id: 0,
      folder_id: 0,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "SFG Transportation Cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "Processing Cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM Landed cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM transportation cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM procurement cost",
      filetype: 2,
      scenario_time: null,
      number: 1481,
    },
  ];
  const nutritionScenarioOptions4 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Landed cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
   
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "SFG Transportation Cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "Processing Cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
  
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM transportation cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM procurement cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
  ];
  const nutritionScenarioOptions5 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM procurement cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM transportation cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  
   
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM Landed cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },

  ];
  const nutritionScenarioOptions6 = [
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "RMPM Landed cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "Processing Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1480,
      folder_id: 347,
      scenario: "SFG Transportation Cost",
      filetype: 2,
      scenario_time: null,
      number: 1480,
    },
    {
      scenario_id: 1477,
      folder_id: 347,
      scenario: "Packaging Cost",
      filetype: 2,
      scenario_time: "",
      number: 1477,
    },
    {
      scenario_id: 0,
      folder_id: 347,
      scenario: "Primary Transportation Cost",
      filetype: 1,
      scenario_time: null,
      number: 1476,
    },
  
  
 

    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM transportation cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
    // {
    //   scenario_id: 1480,
    //   folder_id: 347,
    //   scenario: "RMPM procurement cost",
    //   filetype: 2,
    //   scenario_time: null,
    //   number: 1480,
    // },
];
  
  let scenarioNames;
  
  if (folderModuleName === "module2") {
    scenarioNames = nutritionScenarioOptions2?.map(item => item.scenario);
  } else if (folderModuleName === "module3") {
    scenarioNames = nutritionScenarioOptions3?.map(item => item.scenario)
  } else if (folderModuleName === "module4") {
    scenarioNames = nutritionScenarioOptions4?.map(item => item.scenario)
  }else if (folderModuleName === "module5") {
    scenarioNames = nutritionScenarioOptions5?.map(item => item.scenario)
  }else if (folderModuleName === "module6") {
    scenarioNames = nutritionScenarioOptions6?.map(item => item.scenario)
  } else {
    scenarioNames = nutritionScenarioOptions?.map(item => item.scenario)

  }
  
    const [selectedScenario, setSelectedScenario] = useState([]);
    console.log(selectedScenario, "seseesesee")
  
    const handleScenarioChange = (event) => {
      setSelectedScenario(event.target.value);
  };
  const handleClear = () => {
    setSelectedScenario([]);
  };

  console.log("Result data --Over All:", datasets);

  const filterArray = [];
  if (selectedScenarios) {
    selectedScenarios.map((item) => {
      filterArray?.push(item?.scenario);
    });    
  }
 

  if (selectedScenario.length > 0) {
    const maxDataLength = Math.max(...datasets.map((item) => item.data.length));

    datasets.forEach((item) => {
      let isMatched = false;
      for (const filterString of selectedScenario) {
        if (item?.label.toLowerCase().includes(filterString?.toLowerCase())) {
          isMatched = true;
          break;
        }
      }
      if (!isMatched) {
        item.data = Array(maxDataLength).fill(0);
      }
    });
    }
    console.log(filterArray,datasets, "filterArray");

  const baselineData = {
    // labels: props.data
    //   .sort((a, b) => (a.visit > b.visit ? 1 : -1))
    //   .map((item) => `Week ${item.visit}`),
    labels: labels,
    datasets,
  };

  const labelTimePeriod = props.timPeriodOverAllCost.label;
  const data01 = {
    labels: labelTimePeriod,
    datasets: props.timPeriodOverAllCost.data,
  };


  const data = baselineData?.datasets;
  const sums = Array(data[0].data.length).fill(0);

  data.forEach((item) => {
    item.data.forEach((value, index) => {
      if (value !== null && value !== undefined) {
        sums[index] += value;
      }
    });
  });

  console.log(sums, "sm");

  console.log(selectedScenarios, "selectedScenarios");
 
  useEffect(() => {
    setSelectedScenario([]);
 }, [selectedFolderData])
 
  // console.log( baselineData?.datasets, "baseLineData");
  return (
    <>
      <div className="chart-block">
        <div className="chart-container">
          <div className="dropdown_container">
            <div className="pull-left">
              {" "}
              <h2>Total Cost by Scenario (in Crore)</h2>
            </div>
            <div className="pull-right">
              <FormControl sx={{width: 300 }}>
              <InputLabel id="demo-multiple-checkbox-label">Filter By Cost</InputLabel>
              <Select
                id="scenario-multi-select"
                multiple
                value={selectedScenario}
                onChange={handleScenarioChange}
                input={
                  <OutlinedInput
                    label="Select Scenarios"
                    endAdornment={
                      selectedScenario.length > 0 && (
                        <ClearIcon
                          style={{ cursor: 'pointer' }}
                          onClick={handleClear}
                        />
                      )
                    }
                  />
                }
                renderValue={(selected) => selected.join(', ')}
               
              >
                {scenarioNames?.map((scenario) => (
                  <MenuItem key={scenario} value={scenario}>
                    <Checkbox checked={selectedScenario.indexOf(scenario) > -1} />
                    <ListItemText primary={scenario} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            </div>
          </div>
          <br />
          <div className="sum_container">
            {sums.map((item) => (
              <div>
                {item !== 0 ? (
                  <div className="sum_container_items">{item.toFixed(2)}</div>
                ) : (
                  ""
                )}
              </div>
            ))}
          </div>
          <Bar
            id="overall-cost-by-scenario"
            options={options}
            data={baselineData}
            height="100"
          />
        </div>
      </div>
      {/* <Grid item xs={7} md={7} lg={7} className="chart-block">
                    <div className="chart-container">
                        <h2>Cost comparision split by time</h2>
                        <Bar id="cost-comparision-split-by-time" data={data01} options={options01} />
                    </div>
                </Grid> */}
    </>
  );
}

export default OverAllCostByScenarioChart;
